export default "__VITE_ASSET__D2YXy6ar__"